import { ComponentType, memo, useMemo } from 'react';
import { Invoice as InvoiceType } from './FarmerInvoice';
import useInvoiceHoldingCashQuery from 'hooks/useInvoiceHoldingCashQuery';

export interface InvoiceCollectionProps {
  invoice: InvoiceType;
  paidAt?: string;
  isHoldingCash?: boolean;
  onHoldingCashClick?: () => void;
}

export const withInvoiceCollection = (
  WrappedComponent: ComponentType<InvoiceCollectionProps>,
) => {
  const EnhancedComponent = ({ invoice, ...props }: InvoiceCollectionProps) => {
    const { data } = useInvoiceHoldingCashQuery(invoice?.invoiceId);
    return (
      <WrappedComponent
        invoice={invoice}
        paidAt={data?.paidAt}
        isHoldingCash={!!data?.isHoldingCash}
        {...props}
      />
    );
  };
  return memo(EnhancedComponent);
};
